const apiUrl = process.env.REACT_APP_API_URL;
export const GetJutgeUsuariIdPoints = async (id: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/usuaris/${id}/points`);
        const jsonData = await response.json();
        return Array.isArray(jsonData) ? jsonData : [];
    } catch (error) {
        console.log('Error al obtener los datos:', error);
        return [];
    }
};
